import { useState } from "react";
import { useGetTermsAndConditionPreviewMutation } from "../api/api-hooks/site-config";
import { LanguageCode } from "../api/contracts/site-config";
import { useConfiguration } from "../contexts/ConfigurationProvider";

interface TermsDialogState {
  isOpen: boolean;
  title: string;
  body: string;
  isLoading: boolean; // Add this
}

interface UseTermsDialogReturn {
  termsDialog: TermsDialogState;
  openTermsDialog: (termId: string, languageCode: LanguageCode) => void;
  closeTermsDialog: () => void;
}

export const useTermsDialog = (): UseTermsDialogReturn => {
  const [termsDialog, setTermsDialog] = useState<TermsDialogState>({
    isOpen: false,
    title: "",
    body: "",
    isLoading: false,
  });
  const { configuration } = useConfiguration();
  const siteId = configuration?.siteId || "";

  const { mutateAsync: fetchPreview, isPending } =
    useGetTermsAndConditionPreviewMutation();

  const openTermsDialog = async (
    termId: string,
    languageCode: LanguageCode,
  ) => {
    setTermsDialog((prev) => ({ ...prev, isOpen: true, isLoading: true }));

    try {
      const preview = await fetchPreview({ termId, languageCode, siteId });
      setTermsDialog({
        isOpen: true,
        title: preview.title,
        body: preview.body,
        isLoading: false,
      });
    } catch (error) {
      console.error("Failed to fetch terms preview:", error);
      setTermsDialog((prev) => ({
        ...prev,
        isOpen: false,
        isLoading: false,
      }));
    }
  };

  const closeTermsDialog = () => {
    setTermsDialog((prev) => ({ ...prev, isOpen: false }));
  };

  return {
    termsDialog: {
      ...termsDialog,
      isLoading: termsDialog.isLoading || isPending,
    },
    openTermsDialog,
    closeTermsDialog,
  };
};
